'use client'
import React, {useContext } from 'react';
import { Text } from '@chakra-ui/layout';
import { Icon, IconButton, Menu, MenuButton, MenuItem, MenuList } from '@chakra-ui/react';
import {MdAdd, MdMoreHoriz, MdOutlineDelete } from 'react-icons/md';
import { useDisclosure } from '@chakra-ui/react-use-disclosure';
import { PersonaContext } from '../../lib/personaContext';
import { PersonaPageContext } from '../lib/personaPageContext';
import DeletePersonaModal from '../../components/deletePersonaModal';
export default function PersonaAsideEditMenu() {
  const {
    persona,
    rights,
  } = useContext(PersonaContext);
  const {
    setEditingQuote,
    setEditingAttributes,
    setEditingBio,
    setEditingUsefulLinks,
  } = useContext(PersonaPageContext);
  const modalDelete = useDisclosure();
  return (
    <>
      {(persona && rights.can_update) && (
        <>
          <Menu>
            {({ isOpen }) => (
              <>
                <MenuButton
                  isActive={isOpen}
                  as={IconButton}
                  icon={<MdMoreHoriz />}
                  variant='blueOutline'
                />
                <MenuList>
                  {!persona.bio &&
                    <MenuItem onClick={() => {
                      setEditingBio(true);
                    }}>
                        <Icon
                        as={MdAdd}
                        boxSize={'14px'}
                        mr={2}
                      />
                      Add Bio
                    </MenuItem>
                  }
                  {!persona.quote &&
                    <MenuItem onClick={() => {
                      setEditingQuote(true);
                    }}>
                      <Icon
                        as={MdAdd}
                        boxSize={'14px'}
                        mr={2}
                      />
                      Add Quote
                    </MenuItem>
                  }
                  {!(
                    persona.job
                    || persona.location
                    || persona.age
                    || persona.education
                    || persona.fammily_status
                    || persona.interests
                  ) &&
                    <MenuItem onClick={() => {
                      setEditingAttributes(true)
                    }}>
                      <Icon
                        as={MdAdd}
                        boxSize={'14px'}
                        mr={2}
                      />
                      Add Attributes
                    </MenuItem>
                  }
                  {(!persona.useful_links || persona.useful_links.length === 0) && (
                    <MenuItem onClick={() => {
                      setEditingUsefulLinks(true);
                    }}>
                      <Icon
                        as={MdAdd}
                        boxSize={'14px'}
                        mr={2}
                      />
                      Add Useful Links
                    </MenuItem>
                  )}
                  {rights.can_delete && (
                    <MenuItem onClick={() => {
                      modalDelete.onOpen();
                    }}>
                        <Icon
                        as={MdOutlineDelete}
                        color='text.medium.red'
                        boxSize={'14px'}
                        mr={2}
                      />
                      <Text color='text.medium.red' >Delete</Text>
                      <DeletePersonaModal disclosure={modalDelete} />
                    </MenuItem>
                  )}
                </MenuList>
              </>
            )}
          </Menu>
        </>
      )}
    </>
  )
}
